import moment from 'moment';
export default {
	name: 'date-picker',
	props:{
		id: {
			type: String,
			required: true,
			default: () => 'date'
		},
		showLabel: {
			type: Boolean,
			required: false,
			default: () => true
		},
		startDate: {
			type: Date,
			required: false,
			default: () => new Date()
		},
		endDate: {
			type: Date,
			required: false,
			default: () => null
		},
		required: {
			type: Boolean,
			required: false,
			default: () => true
		},
		errorText: {
			type: String,
			required: false,
			default: () => 'Please select date'
		},
		labelText: {
			type: String,
			required: false,
			default: () => 'Date'
		},
		placeholder: {
			type: String,
			required: false,
			default: () => ''
		},
		defaultDate: {
			type: Date,
			required: false,
			default: () => null
		},
		defaultDateStr: {
			type: String,
			required: false,
			default: () => null
		},
		referenceName: {
			type: String,
			required: false,
			default: () => null
		},
	},
	watch: {
		startDate:function(newVal,oldVal){
			let _self=this;
			_self.startDate=newVal;
			_self.setStartDate(newVal);
		},
		endDate:function(newVal,oldVal){
			let _self=this;
			_self.endDate=newVal;
			_self.setEndDate(newVal);
		},
	},
	data () {
		return {
			datePickerElem:null,
			selectedDate:null,
			datePickerInst:null
		}
	},
	watch: {
		
	},
	created(){
		//init date picker
		this.init();
	},
	mounted(){
		let _self=this;
		_self.showDatePicker();
	},
	methods: {
		getInitialDate(){
			let date=new Date();
			date=new Date(date.toISOString());
			//date.setDate(date.getDate()+1);//
			return date;
		},
		init(){
			let _self=this;
			_self.datePickerElem='datePicker_'+this.id;
			_self.getInitialDate();
		},
		showDatePicker(){
			let _self=this;
			_self.applyDatePicker();
		},
		setStartDate(){
			let _self=this;
			$('#'+_self.datePickerElem).datepicker('setStartDate', _self.startDate)
		},
		setEndDate(){
			let _self=this;
			$('#'+_self.datePickerElem).datepicker('setEndDate', _self.endDate);
		},
		setDefaultDate(){
			let _self=this;
			let defaultDateVal=null;
			let defaultDate=null;
			if(_self.defaultDateStr!=null && _self.defaultDateStr!=''){
				defaultDate=new Date(_self.defaultDateStr.split('/')[2],(parseInt(_self.defaultDateStr.split('/')[1])-1),_self.defaultDateStr.split('/')[0]);
				defaultDateVal=_self.formatDateValue(defaultDate);				
			}
			if(_self.defaultDate!=null){
				defaultDate=	_self.defaultDate;
				defaultDateVal=_self.formatDateValue(defaultDate);				
			}
			if(defaultDateVal!=null){
				//$('#'+_self.datePickerElem).datepicker( "setDate", _self.defaultDate);
				$('#'+_self.datePickerElem).datepicker( "setDate", defaultDate);
				$('#'+_self.datePickerElem).datepicker('update');
			}
		},
		formatDateValue(date){
			return moment(date).format('MM/DD/YYYY');
		},
		applyDatePicker(){
			let _self=this;
			_self.datePickerInst=$('#'+_self.datePickerElem).datepicker({
				autoclose:true,
				todayBtn:'linked',
				todayHighlight:true
			})
			.on('changeDate', function(ev){
        		// if (ev.date.valueOf() > endDate.valueOf()){
          //   		$('#alert').show().find('strong').text('The start date must be before the end date.');
        		// } else {
          //   		$('#alert').hide();
          //   		startDate = new Date(ev.date);
          //   		_self.onDateChanged(ev);
          //   		$('#date-start-display').text($('#date-start').data('date'));
				// }
        		_self.onDateChanged(ev);
        		_self.hideDatePicker();
			});
			setTimeout(function(){
				_self.setDefaultDate();},200);

		},
		toggleCalendar(){

		},
		hideDatePicker(){
			let _self=this;
			$('#'+_self.datePickerElem).datepicker('hide');
		},
		onDateChanged(en){
			let _self=this;
			let date=en.date;
			//date cleared
			if(en.target.value=='')
				date=null;
			this.$emit('onDateChanged',date,en);
		}
	}
}

